export const META = "meta";
export const LINKEDIN = "linkedin";
export const URL_PARAM_PLATFORM = "platform";
export const URL_PARAM_CONNECTING_SOCIAL_MEDIA_USER_UUID = "connecting_social_media_user_uuid";
